import { useState } from "react";
import { media, srcSet } from "@/lib/api";
import { MediaShield } from "./Protect";

export const PhotoImg = ({ photo, sizes = "(max-width: 768px) 100vw, 50vw", className = "", eager = false, alt, testid }) => {
  const [loaded, setLoaded] = useState(false);
  if (!photo?.urls?.medium) return <div className={`bg-[#141414] ${className}`} />;
  return (
    <div className={`relative overflow-hidden ${className}`} style={{ backgroundColor: photo.color || "#141414" }}>
      {photo.lqip && <img src={photo.lqip} alt="" aria-hidden className={`absolute inset-0 h-full w-full scale-110 object-cover blur-xl transition-opacity duration-700 ${loaded ? "opacity-0" : "opacity-100"}`} />}
      <img data-testid={testid} src={media(photo.urls.medium)} srcSet={srcSet(photo)} sizes={sizes} alt={alt || photo.alt || photo.title}
        loading={eager ? "eager" : "lazy"} decoding="async" onLoad={() => setLoaded(true)}
        className={`absolute inset-0 h-full w-full object-cover transition-[opacity,transform] duration-[1200ms] ease-out ${loaded ? "opacity-100" : "opacity-0"}`} />
      <MediaShield />
    </div>
  );
};
